import { render } from "./CadastroRealizado.vue?vue&type=template&id=789eb51c&scoped=true"
import script from "./CadastroRealizado.vue?vue&type=script&lang=js"
export * from "./CadastroRealizado.vue?vue&type=script&lang=js"

import "./CadastroRealizado.vue?vue&type=style&index=0&id=789eb51c&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789eb51c"]])

export default __exports__